import tokens from '@lmig/lmds-tokens/dist/json/core/breakpoint.json';
var defaultThresholdMap = function defaultThresholdMap() {
  return {
    base: 0,
    sm: tokens.lmig.breakpoint.sm.raw,
    md: tokens.lmig.breakpoint.md.raw,
    lg: tokens.lmig.breakpoint.lg.raw,
    xl: tokens.lmig.breakpoint.xl.raw
  };
};
export default defaultThresholdMap();


//////////////////
// WEBPACK FOOTER
// ./node_modules/@lmig/lmds-react-icons/dist/_esm/util/defaultThresholdMap.js
// module id = 939
// module chunks = 0